<template>

    <gcmcn-modal
        :show="show"
        :closeOnClickModal="false"
        :height="0"
        @close="handleClose"
    >
        <el-form
            ref="form"
            :model="latency"
            :rules="rules"
            class="latency-form"
            label-width="130px"
        >
            <el-form-item class="gcmcn-input" label="Name" prop="name">
                <el-input v-model="latency.name"></el-input>
            </el-form-item>
            <el-form-item class="gcmcn-input" label="Value (ms)" prop="value_ms">
                <el-input v-model="latency.value_ms"></el-input>
            </el-form-item>
            <el-form-item class="gcmcn-input" label="Default">
                <el-switch
                    v-model="latency.default"
                    :disabled="latency.default == true"
                    active-text="Yes"
                    inactive-text="No"
                ></el-switch>
            </el-form-item>
        </el-form>
        <div class="latency-modal-footer">
            <el-button
                type="text"
                @click="show = false"
            >Cancel</el-button>
            <el-button
                type="primary"
                @click="save"
            >Save</el-button>
        </div>
    </gcmcn-modal>
</template>

<script>

import GcmcnModal from 'gcmcn-common/src/components/gcmcn-modal-theme.vue';
import { cloneDeep } from 'lodash';
export default {

    components: {
        GcmcnModal,
    },

    props: {

    },

    data (){
        const checkValueMs = (rule, value, callback) => {
            if(!value || value.toString().includes('.') || isNaN(value)){
                return callback(new Error('Value must be a valid integer'));
            }
            callback();
        };
        return {
            show: false,
            latency: {
                name: '',
                value_ms: '',
                default: false,
            },
            rules: {
                name: [{required: true, type: 'string'}],
                value_ms: [{ validator: checkValueMs, required: true }],
            }
        };
    },

    computed: {
        edit (){
            return this.latency.uid !== undefined;
        },
    },

    mounted (){

    },

    methods: {
        open (latency=null){
            if(latency){
                this.$set(this, 'latency', cloneDeep(latency));
            }
            this.show = true;
        },
        save (){
            this.$refs.form.validate((value) => {
                if(value){
                    let method = 'patchItem';
                    let toSave = {
                        model: 'latencies',
                        item: this.latency,
                    }
                    if(!this.edit){
                        method = 'createItem';
                        toSave.url = this.$store.state.api.meta.listModels.latencies.url;
                    }

                    this.$store.dispatch(method, toSave).then((res) => {
                        this.$emit('latency-saved');
                        this.show = false;
                        this.$notify({
                            type: 'success',
                            title: 'Latency saved!',
                        });
                    }).catch((e) => {
                        console.error(e);
                        this.$notify({
                            type: 'error',
                            title: 'Error on save latency',
                        });
                    });
                }
            });
        },
        handleClose (){
            this.$set(this, 'latency', {
                name: '',
                value_ms: '',
                default: false,
            });
        },
    },
};
</script>

<style lang="scss">
.latency-form{
    .gcmcn-input {
        margin-top: 25px;
    }
    .gcmcn-input label{
        margin-top: 0;
    }
    .el-select{
        width: 100%;
    }

}
.latency-modal-footer{
    display: flex;
    justify-content: flex-end;
    .el-button--text{
        color: #bbb;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/page/Setting/Latency/modal-edit-latency.vue